import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import * as globalConstant from './../global_constant';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError,map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CartService {
    private subject = new Subject<any>();
    orderOverview = globalConstant.ORDER_OVERVIEW;
    siteRequestFrom = globalConstant.SITE_REQUEST_FROM;
    apiDomain = globalConstant.DOMAIN;

    constructor(public router: Router, private http: HttpClient) {

    }
	
    sendMessage(message: string) {
        this.subject.next(message);
    }
    
    clearMessages() {
        this.subject.next(true);
    }

    getMessage(): Observable<any> {
        return this.subject.asObservable();
    }

    getOrderOverview(data) {
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				'requestFrom': this.siteRequestFrom,
			})
		};
		return this.http.post<any>(this.apiDomain + this.orderOverview, data, httpOptions).pipe(map(res => {
			return res;
		}),
        catchError(err => {
            return err.error;
          }));
	}
}